import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Template from "../components/template";
import DepartmentList from "../floor/departmentList";
import { setHospitalTDK } from "utils/hospital";

// 医生主页
const DepartList = () => {
  const params = useParams<Record<any, any>>();
  const [pageId, setPageId] = useState<any>(params.id);
  useEffect(() => {
    if (params.id) {
      setPageId(params.id);
    }
  }, []);
  return (
    <Template breadTitle="科室列表">
      {
        (hospitalInfo: any) => {
          // 设置TDK
          setHospitalTDK(
            `${hospitalInfo?.hospitalName}科室列表 - 京东健康互联网医院`,
            `${hospitalInfo?.hospitalName}科室列表`,
            `${hospitalInfo?.hospitalName}科室列表`
          );
          return <DepartmentList showAll={true} pageId={pageId} />
        }
      }
    </Template>
  );
};

export default DepartList;
